import axios from "axios";
import type { ILogRepository } from "~/interfaces/ILogRepository";

export class LogRepository implements ILogRepository {
  async sendPwaUsageLog(data: Record<string, any>): Promise<void> {
    const apiBaseUrl = useRuntimeConfig().public.contentsBrowseLoggingApiBaseUrl as string;
    await axios.post(`${apiBaseUrl}`, JSON.stringify(data));
  }
}
